// @flow
import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import Responsive from 'react-responsive';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Desktop } from '../../../../utils/responsive';
import Drawer from '../../../../elements/Drawer/Drawer';

import icons from '../../../../assets/styles/icons.scss';
import style from './NotLoggedMenu.scss';
import navbarStyle from '../Navbar.scss';
import type { LocaleState } from '../../../locale/duck';

type Props = {
  +open: boolean;
  +close: (e: Event) => void;
  +handleOpenModal: (e: Event, openLoginView: boolean) => false;
  +locale: LocaleState;
};

export default class NotLoggedMenu extends Component<Props> {
  handleClickOutside(e: Event) {
    const { close } = this.props;
    const wrap = document.querySelector(`.${style.notLoggedMenuWrap}`);
    const mainWrap = document.querySelector(`.${navbarStyle.notLoggedMenu}`);
    const burger = document.querySelector(`.${navbarStyle.burger}`);
    if (wrap && mainWrap && burger && e.target instanceof Node) {
      const target = e.target;
      if (!mainWrap.contains(target) && !wrap.contains(target) && !burger.contains(target)) {
        close(e);
      }
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  componentWillUnmount() {
    // Ensure to remove listener if loggedout with menu open
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  render() {
    const { open, close, handleOpenModal, locale } = this.props;
    // if (!open) return null;
    const responsiveMenu = open && <Fragment>
      <Helmet>
        <style type="text/css">{`
          body {
              overflow: hidden!important;
          }
        `}</style>
      </Helmet>
      <section className={style.notLoggedMenuWrap}>
        <ul>
          <li><FormattedMessage id="auth.title">{
            txt => <Link onClick={(e: Event) => close(e)}
                         to="/login"
                         className={style.login}>
              {txt}{/*<i className={icons.symbolLogIn}/>*/}</Link>
          }</FormattedMessage></li>
          <li><FormattedMessage id="signup.title">{
            txt => <Link onClick={(e: Event) => close(e)}
                         to="/sign-up"
                         className={style.signUp}>
              {txt}{/*<i className={icons.symbolRegister}/>*/}</Link>
          }</FormattedMessage></li>
          {/*<li><FormattedMessage id="nav.loggedMenu.buyer.label">{
            txt => <p className={style.subtitle}>{txt}</p>
          }</FormattedMessage></li>*/}
          <li className={style.buy}><FormattedMessage id="nav.buyBig">{
            txt => <Link onClick={close} to="/">
              {txt}{/*<i className={icons.iconBagMedium}/>*/}</Link>
          }</FormattedMessage></li>
          {/*<li><FormattedMessage id="nav.loggedMenu.traveler.label">{
            txt => <p className={style.subtitle}>{txt}</p>
          }</FormattedMessage></li>*/}
          <li className={style.flight}><FormattedMessage id={locale.domainCountry === 'CO' ? 'nav.earn.CO' : 'nav.earn'}>{
            txt => <Link onClick={close} to="/preferences/referral">
              {txt}{/*<i className={icons.iconAirplaneAddMedium}/>*/}</Link>
          }</FormattedMessage></li>
          {/*<li className={style.help}><FormattedMessage id="nav.loggedMenu.general.label">{
            txt => <p className={style.subtitle}>{txt}</p>
          }</FormattedMessage></li>*/}
          <li className={style.help}><FormattedMessage id="nav.loggedMenu.help">{
            txt => <a onClick={close}
                      className={style.faqLabel}
                      href="https://help.qempo.com/"
                      target="_blank">
              {txt}{/*<i className={icons.symbolQuestionCircle}/>*/}</a>
          }</FormattedMessage></li>
        </ul>
      </section>
    </Fragment>;
    return (
      <Fragment>
        {/*<Desktop>
          <aside className={classNames(style.notLoggedMenuWrap, { [style.open]: open })}>
            <section className={style.notLoggedMenuContent}>
              <ul>
                <li><FormattedMessage id="auth.title">{
                  txt => <Link onClick={(e: Event) => handleOpenModal(e, true)}
                               to="/login"
                               className={style.buy}>
                    {txt}<i className={icons.symbolLogIn}/></Link>
                }</FormattedMessage></li>
                <li><FormattedMessage id="signup.title">{
                  txt => <Link onClick={(e: Event) => handleOpenModal(e, false)}
                               to="/sign-up"
                               className={style.signUp}>
                    {txt}<i className={icons.symbolRegister}/></Link>
                }</FormattedMessage></li>
                <li><FormattedMessage id="nav.loggedMenu.buyer.label">{
                  txt => <p className={style.subtitle}>{txt}</p>
                }</FormattedMessage></li>
                <li><FormattedMessage id="nav.buyBig">{
                  txt => <Link onClick={close} to="/new-order"
                               className={style.buy}>
                    {txt}<i className={icons.iconBagMedium}/></Link>
                }</FormattedMessage></li>
                <li><FormattedMessage id="nav.loggedMenu.traveler.label">{
                  txt => <p className={style.subtitle}>{txt}</p>
                }</FormattedMessage></li>
                <li><FormattedMessage id="nav.travelBig">{
                  txt => <Link onClick={close} to="/new-flight"
                               className={style.createFlight}>
                    {txt}<i className={icons.iconAirplaneAddMedium}/></Link>
                }</FormattedMessage></li>
                <li className={style.help}><FormattedMessage id="nav.loggedMenu.general.label">{
                  txt => <p className={style.subtitle}>{txt}</p>
                }</FormattedMessage></li>
                <li className={style.help}><FormattedMessage id="nav.loggedMenu.help">{
                  txt => <a onClick={close}
                            href="https://help.qempo.com/"
                            target="_blank">
                    {txt}<i className={icons.symbolQuestionCircle}/></a>
                }</FormattedMessage></li>
              </ul>
            </section>
          </aside>
        </Desktop>*/}
        <Responsive maxWidth={991}>
          <Drawer open={open}
                  handleClickOutside={close}>
            {responsiveMenu}
          </Drawer>
        </Responsive>
      </Fragment>
    );
  }
};

NotLoggedMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/navbar/components/not-logged-menu/NotLoggedMenu.jsx